// trainingService.js
import api from "Common/Client/Interceptor";

export const fetchTrainingGroupData = async (adminId, token) => {
  try {
    const response = await api.get(`/TrainingGroup/FormGroup/Information?AdminId`, {
      headers: {
        Authorization: `Bearer ${token}`,
        Accept: "*/*",
      },
    });

    return {
      learners: response.data.trainingRequests || [],
      mentors: response.data.mentors || [],
    };
  } catch (error) {
    console.error("Error fetching training group data:", error.response?.data || error);
    return { learners: [], mentors: [] };
  }
};

export const fetchTeamsByMentor = async (mentorId, token) => {
  try {
    const response = await api.get(`/TrainingGroup/TeamNames/List?mentorId=${mentorId}`, {
      headers: {
        Authorization: `Bearer ${token}`,
        Accept: "*/*",
      },
    });
    return response.data || [];
  } catch (error) {
    console.error("Error fetching teams:", error.response?.data || error);
    return [];
  }
};

// trainingService.js
export const createTrainingGroup = async (groupData, token) => {
  try {
    const response = await api.post("/TrainingGroup/Create", groupData, {
      headers: {
        Authorization: `Bearer ${token}`,
        Accept: "*/*",
        "Content-Type": "application/json",
      },
    });
    return response.data;
  } catch (error) {
    throw error
  }
};

export const fetchTrainingDetail = async (adminId, token) => {
  try {
    const response = await api.get(`/TrainingGroup/Admin/List?AdminId=${adminId}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};
